import { IS_TAZ } from "@/utils/brand"

export const b2cPolicies = {
    clientId: import.meta.env.VITE_AZURE_AD_CLIENT_ID || "",
    names: {
        signUpSignIn: "B2C_1A_SIGNUP_SIGNIN",
        forgotPassword: "B2C_1A_PASSWORDRESET",
        // editProfile: "B2C_1A_profile_edit",
    },
    authorities: {
        signUpSignIn: {
            authority: import.meta.env.VITE_AZURE_AD_SIGN_IN_AUTHORITY || "",
        },
        forgotPassword: {
            authority: "",
        },
        editProfile: {
            authority: "",
        },
    },
    authorityDomain: [import.meta.env.VITE_AZURE_AD_AUTHORITY_DOMAIN || ""],
}

export const msalConfig = {
    auth: {
        clientId: b2cPolicies.clientId,
        authority: b2cPolicies.authorities.signUpSignIn.authority, // Choose SUSI as your default authority.
        knownAuthorities: b2cPolicies.authorityDomain,
        redirectUri: "/",
        navigateToLoginRequestUrl: true,
    },
    cache: {
        cacheLocation: "localStorage",
        // TAZ only: persist interim auth state in a cookie so the hidden-iframe /
        // redirect silent renewal survives strict third-party-cookie handling on
        // locked-down government browsers. B2C envs keep the default behaviour.
        ...(IS_TAZ ? { storeAuthStateInCookie: true } : {}),
    },
    // TAZ only: give the hidden-iframe silent renewal more headroom on slow
    // private networks before it times out and forces an interactive redirect.
    ...(IS_TAZ
        ? {
              system: {
                  iframeHashTimeout: 10000,
                  windowHashTimeout: 60000,
              },
          }
        : {}),
}

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: ["openid", "profile"],
}
